/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import { Link, Message as MessageDialog } from '@bwoty-web/styleguide';

import styles from './Message.scss';

export const Message = ({ header, message, type, id, program, onResetFilters }) => {
  let messageType = 'info';

  if (type === 'Error') {
    messageType = 'error';
  } else if (type === 'Warning') {
    messageType = 'warning';
  }

  if (id === 'noFilteredResult' && program === 'lms') {
    const parts = `${message}`.split(/{|}/);

    if (parts.length >= 2) {
      return (
        <MessageDialog messageType={messageType} header={header} initiallyExpanded>
          {parts[0]}
          <Link onClick={onResetFilters} className={styles.link}>
            {parts[1]}
          </Link>
          {parts[2]}
        </MessageDialog>
      );
    }
  }

  return (
    <MessageDialog messageType={messageType} header={header}>
      {message}
    </MessageDialog>
  );
};

Message.propTypes = {
  type: PropTypes.string,
  header: PropTypes.node,
  message: PropTypes.node,
  id: PropTypes.string,
  program: PropTypes.string,
  onResetFilters: PropTypes.func,
};

Message.defaultProps = {
  onResetFilters: () => {},
  type: '',
};
